import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({

  formContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  paper: {
    display: 'flex',
    margin: '0px',
    padding: '24px',
    gap: '24px',
    flex: 1,
    flexDirection: 'column',
    paddingBottom: '0px',
    flexGrow: 1,
    '@media (min-width: 640px)': {
      flexDirection: 'row',
      margin: '20px',
    },
    '@media (max-width: 640px)': {
      borderRadius: '0px',
      borderColor: theme.evPalette.charcoal[300],
    },
  },

  paperLoading: {
    display: 'flex',
    margin: '0px',
    padding: '24px',
    marginTop: '56px !important',
    gap: '24px',
    flex: 1,
    flexDirection: 'column',
    paddingBottom: '0px',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
      margin: '20px',
    },
    '@media (max-width: 640px)': {
      borderRadius: '0px',
      marginTop: '0px !important',
      marginBottom: '1px !important',
    },
  },

  pageHeader: {
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '24px',
    textAlign: 'left',
    margin: '0px',
    paddingTop: '16px',
    paddingLeft: '24px',
    width: '100%',
    '@media (max-width: 640px)': {
      paddingTop: '0px',
      paddingLeft: '0px',
    },
  },

  paymentInformationTitle: {
    fontFamily: 'Noto Sans',
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '27px',
    textAlign: 'left',
    color: '#005A8D',
    marginBottom: '1.5rem',
  },

  label: {
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    textAlign: 'left',
    color: '#4D5365',
    gap: '0px',
    '&.Mui-error': {
      color: `${theme.evPalette.rose[900]} !important`,
    },
  },

  asterisk: {
    color: '#BC1616',
  },

  inputFieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },

  inputField: {
    maxWidth: '782px',
    gap: '10px',
    borderRadius: '4px',
    border: '1px',
  },
  textHelp: {
    margin: '0px',
  },

  cardContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
  },

  cardTypeContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    maxWidth: '208px',
    width: '100%',
  },

  cardTypeOptions: {
    height: '40px',
  },

  cardNumberContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    maxWidth: '558px',
    width: '100%',
  },

  expirationContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
  },
  addressInformationContainer: {
    gap: '24px',
  },
  addressTitleContainer: {
    gap: '6px',
  },

  addressInformationTitle: {
    fontFamily: 'Noto Sans',
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '27px',
    textAlign: 'left',
    color: theme.evPalette.ocean[700],
  },

  addressInformationMessage: {
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    textAlign: 'left',
  },
  // #genai
  paymentMethodContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  paymentMethodLabel: {
    fontWeight: 600,
    color: theme.evPalette.charcoal[900],
  },
  paymentMethodOptions: {
    gap: theme.spacing(2),
    '@media (max-width: 640px)': {
      flexDirection: 'column',
    },
  },
  paymentMethodOption: {
    border: `1px solid ${theme.evPalette.charcoal[300]}`,
    borderRadius: theme.spacing(1),
    cursor: 'pointer',
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1.5)}px`,
    width: 'fit-content',
    '& .myev-MuiCheckbox-root': {
      padding: theme.spacing(0.5),
    },
  },
  paymentMethodOptionSelected: {
    borderColor: theme.evPalette.ocean[600],
    backgroundColor: theme.evPalette.ocean[50],
  },
  // #genai Phase 2 "Payment method added" success banner (Figma 331:26943 / 331:27171). Owns its
  // own page margin (20px, matching the saved-methods / empty-state chrome) since it renders at the
  // page level above the child element. Rounded light-green box with no border hairline; title
  // bumped to the Figma's 18/27 SemiBold and 16px gaps between the title/body and body paragraphs.
  // !important wins over the shared Banner's default borderRadius:0 + lime-700 border-bottom.
  successBanner: {
    margin: '20px 20px 0',
    borderRadius: '4px !important',
    borderBottom: 'none !important',
    alignItems: 'flex-start',
    '& .title': {
      fontSize: '18px',
      lineHeight: '27px',
      fontWeight: 600,
    },
    '& .title + .message': {
      marginTop: '16px',
    },
    '& .message > div + div': {
      marginTop: '16px',
    },
    '@media (max-width: 639px)': {
      margin: '16px 16px 0',
    },
  },
}));
